const {GEAR_HIDE_ARMOR} = require('./../../../../../gearIdList')

module.exports = GEAR_HIDE_ARMOR
